import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "section" }
const _hoisted_2 = { class: "width-wrap" }
const _hoisted_3 = { class: "page-navbar" }
const _hoisted_4 = { class: "nav-tabs" }
const _hoisted_5 = {
  key: 0,
  class: "section pb-0"
}
const _hoisted_6 = {
  key: 0,
  class: "form-messages"
}
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = { for: "frm-estateAddForm_title" }
const _hoisted_10 = ["placeholder"]
const _hoisted_11 = { class: "help" }
const _hoisted_12 = {
  key: 0,
  class: "form-error"
}
const _hoisted_13 = {
  key: 1,
  class: "form-error"
}
const _hoisted_14 = { class: "form-field" }
const _hoisted_15 = { for: "frm-estateAddForm_estateFrontSubType" }
const _hoisted_16 = { class: "selectbox" }
const _hoisted_17 = ["value"]
const _hoisted_18 = { for: "frm-estateAddForm_estateArea" }
const _hoisted_19 = ["placeholder"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "help" }, [
  /*#__PURE__*/_createTextVNode(" v m "),
  /*#__PURE__*/_createElementVNode("sup", null, "2")
], -1)
const _hoisted_21 = {
  key: 0,
  class: "form-error"
}
const _hoisted_22 = {
  key: 1,
  class: "form-error"
}
const _hoisted_23 = {
  key: 2,
  class: "form-error"
}
const _hoisted_24 = { class: "form-field" }
const _hoisted_25 = { for: "frm-estateAddForm_floor" }
const _hoisted_26 = { class: "selectbox" }
const _hoisted_27 = ["value"]
const _hoisted_28 = { class: "form-field" }
const _hoisted_29 = { for: "frm-estateAddForm_otherProperties" }
const _hoisted_30 = { class: "checkboxlist grid-2" }
const _hoisted_31 = { class: "checkbox-wrap has-textinput" }
const _hoisted_32 = { class: "checkbox" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_34 = {
  key: 0,
  class: "input-wrap has-hint"
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("span", { class: "hint" }, "v m²", -1)
const _hoisted_36 = { class: "checkbox-wrap has-textinput" }
const _hoisted_37 = { class: "checkbox" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_39 = {
  key: 0,
  class: "input-wrap has-hint"
}
const _hoisted_40 = /*#__PURE__*/_createElementVNode("span", { class: "hint" }, "v m²", -1)
const _hoisted_41 = { class: "checkbox-wrap has-textinput" }
const _hoisted_42 = { class: "checkbox" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_44 = {
  key: 0,
  class: "input-wrap has-hint"
}
const _hoisted_45 = /*#__PURE__*/_createElementVNode("span", { class: "hint" }, "v m²", -1)
const _hoisted_46 = { class: "form-group" }
const _hoisted_47 = { for: "frm-estateAddForm_price" }
const _hoisted_48 = ["placeholder", "disabled"]
const _hoisted_49 = { class: "help" }
const _hoisted_50 = { class: "checkbox" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_52 = {
  key: 0,
  class: "form-error"
}
const _hoisted_53 = {
  key: 1,
  class: "form-error"
}
const _hoisted_54 = {
  key: 2,
  class: "form-error"
}
const _hoisted_55 = { for: "frm-estateAddForm_status" }
const _hoisted_56 = { class: "selectbox" }
const _hoisted_57 = { value: null }
const _hoisted_58 = ["value"]
const _hoisted_59 = {
  key: 0,
  class: "form-error"
}
const _hoisted_60 = /*#__PURE__*/_createElementVNode("div", { class: "form-footer" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "form-field" }, [
    /*#__PURE__*/_createElementVNode("input", {
      type: "submit",
      class: "button button--primary",
      value: "Vložiť"
    })
  ])
], -1)
const _hoisted_61 = {
  key: 1,
  class: "section pb-0"
}
const _hoisted_62 = { class: "form mt-6" }
const _hoisted_63 = {
  key: 0,
  class: "form-messages"
}
const _hoisted_64 = ["innerHTML"]
const _hoisted_65 = {
  key: 1,
  class: "form-messages"
}
const _hoisted_66 = {
  key: 0,
  class: "flashmessage flash-danger"
}
const _hoisted_67 = { class: "form-footer" }
const _hoisted_68 = { class: "form-field" }
const _hoisted_69 = { class: "columns is-2 is-vertical-centered" }
const _hoisted_70 = { class: "column" }
const _hoisted_71 = { class: "form-upload-file aspect-ratio aspect-ratio-16-9 full-width mt-0" }
const _hoisted_72 = { class: "aspect-ratio-body" }
const _hoisted_73 = {
  class: "upload-placeholder placeholder-empty",
  for: "import-file"
}
const _hoisted_74 = { class: "upload-placeholder-title" }
const _hoisted_75 = { class: "column" }
const _hoisted_76 = { class: "font-size-bigger" }
const _hoisted_77 = { class: "mt-0" }
const _hoisted_78 = { class: "font-size-smaller font-weight-light" }
const _hoisted_79 = ["href"]
const _hoisted_80 = {
  key: 0,
  class: "form-field"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FlashMessage = _resolveComponent("FlashMessage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", null, _toDisplayString(_ctx.$t('AdDeveloperProjectItem.title-insert')), 1),
      _createElementVNode("nav", _hoisted_3, [
        _createElementVNode("ul", _hoisted_4, [
          _createElementVNode("li", {
            class: _normalizeClass({ 'is-active': _ctx.tabActiveIndex === 0 })
          }, [
            _createElementVNode("a", {
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.tabNavigate(0)), ["stop","prevent"]))
            }, _toDisplayString(_ctx.$t('AdDeveloperProjectItem.tab-manual')), 1)
          ], 2),
          _createElementVNode("li", {
            class: _normalizeClass({ 'is-active': _ctx.tabActiveIndex === 1 })
          }, [
            _createElementVNode("a", {
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.tabNavigate(1)), ["stop","prevent"]))
            }, _toDisplayString(_ctx.$t('AdDeveloperProjectItem.tab-import')), 1)
          ], 2)
        ])
      ]),
      (_ctx.tabActiveIndex === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("form", {
              class: _normalizeClass(["form", { 'disabled-all': _ctx.isLoading }]),
              onSubmit: _cache[16] || (_cache[16] = _withModifiers(($event: any) => (_ctx.save()), ["prevent"])),
              autocomplete: "off"
            }, [
              (_ctx.showFormMessages)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (error, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "flashmessage flash-danger",
                        innerHTML: error
                      }, null, 8, _hoisted_7))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", {
                  class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.title.$error }])
                }, [
                  _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t('AdDeveloperProjectItem.title')) + ":", 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.v$.form.title.$model) = $event)),
                    type: "text",
                    id: "frm-estateAddForm_title",
                    placeholder: _ctx.$t('AdDeveloperProjectItem.title-placeholder'),
                    name: "title",
                    class: "form-control is-required"
                  }, null, 8, _hoisted_10), [
                    [
                      _vModelText,
                      _ctx.v$.form.title.$model,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('AdDeveloperProjectItem.title-help', { currentCount: _ctx.form.title ? _ctx.form.title.length : 0, maxCount: _ctx.v$.form.title.maxLength.$params.max })), 1),
                  (_ctx.v$.form.title.$dirty && _ctx.v$.form.title.$invalid)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_ctx.v$.form.title.required.$invalid)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.$t('forms.required')), 1))
                          : _createCommentVNode("", true),
                        (_ctx.v$.form.title.maxLength.$invalid)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.$t('forms.max', { count: _ctx.v$.form.title.maxLength.$params.max })), 1))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true)
                ], 2),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t('AdDeveloperProjectItem.estateFrontSubType')) + ":", 1),
                  _createElementVNode("div", _hoisted_16, [
                    _withDirectives(_createElementVNode("select", {
                      id: "frm-estateAddForm_estateFrontSubType",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.v$.form.estateFrontSubType.$model) = $event)),
                      name: "estateFrontSubType",
                      class: "form-control is-required"
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.estateSubTypes, (item) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: item.key,
                          key: item.key
                        }, _toDisplayString(item.value), 9, _hoisted_17))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.v$.form.estateFrontSubType.$model]
                    ])
                  ])
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.estateArea.$error }])
                }, [
                  _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t('AdDeveloperProjectItem.estateArea')) + ": ", 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.v$.form.estateArea.$model) = $event)),
                    type: "text",
                    id: "frm-estateAddForm_estateArea",
                    placeholder: _ctx.$t('AdDeveloperProjectItem.estateArea-placeholder'),
                    name: "estateArea",
                    class: "form-control is-required"
                  }, null, 8, _hoisted_19), [
                    [
                      _vModelText,
                      _ctx.v$.form.estateArea.$model,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  _hoisted_20,
                  (_ctx.v$.form.estateArea.$dirty && _ctx.v$.form.estateArea.$invalid)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_ctx.v$.form.estateArea.required.$invalid)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.$t('forms.required')), 1))
                          : _createCommentVNode("", true),
                        (_ctx.v$.form.estateArea.decimal.$invalid)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(_ctx.$t('forms.decimal')), 1))
                          : _createCommentVNode("", true),
                        (_ctx.v$.form.estateArea.minValue.$invalid)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_ctx.$t('forms.minValueExclude', { value: 0 })), 1))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true)
                ], 2),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.$t('AdDeveloperProjectItem.floor')) + ":", 1),
                  _createElementVNode("div", _hoisted_26, [
                    _withDirectives(_createElementVNode("select", {
                      id: "frm-estateAddForm_floor",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.v$.form.floor.$model) = $event)),
                      name: "floor",
                      class: "form-control is-required"
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.floors, (item) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: item.key,
                          key: item.key
                        }, _toDisplayString(item.value), 9, _hoisted_27))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.v$.form.floor.$model]
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("label", _hoisted_29, _toDisplayString(_ctx.$t('AdDeveloperProjectItem.otherProperties')) + ":", 1),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("label", _hoisted_32, [
                      _createTextVNode(_toDisplayString(_ctx.$t('AdDeveloperProjectItem.hasBalcony')) + " ", 1),
                      _withDirectives(_createElementVNode("input", {
                        name: "frm-registerForm-balcony",
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.hasBalcony) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.hasBalcony]
                      ]),
                      _hoisted_33
                    ]),
                    (_ctx.hasBalcony)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                          _withDirectives(_createElementVNode("input", {
                            name: "frm-registerForm-balconyArea",
                            class: "form-control",
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.v$.form.balconyArea.$model) = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.v$.form.balconyArea.$model]
                          ]),
                          _hoisted_35
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("label", _hoisted_37, [
                      _createTextVNode(_toDisplayString(_ctx.$t('AdDeveloperProjectItem.hasLoggia')) + " ", 1),
                      _withDirectives(_createElementVNode("input", {
                        name: "frm-registerForm-loggia",
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.hasLoggia) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.hasLoggia]
                      ]),
                      _hoisted_38
                    ]),
                    (_ctx.hasLoggia)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                          _withDirectives(_createElementVNode("input", {
                            name: "frm-registerForm-loggiaArea",
                            class: "form-control",
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.v$.form.loggiaArea.$model) = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.v$.form.loggiaArea.$model]
                          ]),
                          _hoisted_40
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_41, [
                    _createElementVNode("label", _hoisted_42, [
                      _createTextVNode(_toDisplayString(_ctx.$t('AdDeveloperProjectItem.hasTerrace')) + " ", 1),
                      _withDirectives(_createElementVNode("input", {
                        name: "frm-registerForm-terrace",
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.hasTerrace) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.hasTerrace]
                      ]),
                      _hoisted_43
                    ]),
                    (_ctx.hasTerrace)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                          _withDirectives(_createElementVNode("input", {
                            name: "frm-registerForm-terraceArea",
                            class: "form-control",
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.v$.form.terraceArea.$model) = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.v$.form.terraceArea.$model]
                          ]),
                          _hoisted_45
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_46, [
                _createElementVNode("div", {
                  class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.price.$error }])
                }, [
                  _createElementVNode("label", _hoisted_47, _toDisplayString(_ctx.$t('AdDeveloperProjectItem.price')) + ": ", 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.v$.form.price.$model) = $event)),
                    type: "text",
                    id: "frm-registerForm_price",
                    placeholder: _ctx.$t('AdDeveloperProjectItem.price-placeholder'),
                    disabled: _ctx.form.hasEmptyPrice,
                    name: "price",
                    class: "form-control is-required"
                  }, null, 8, _hoisted_48), [
                    [
                      _vModelText,
                      _ctx.v$.form.price.$model,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.$t('AdDeveloperProjectItem.price-help')), 1),
                  _createElementVNode("label", _hoisted_50, [
                    _createTextVNode(_toDisplayString(_ctx.$t('AdDeveloperProjectItem.hasEmptyPrice')) + " ", 1),
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      id: "frm-estateAddForm_emptyPrice",
                      name: "hasEmptyPrice",
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.v$.form.hasEmptyPrice.$model) = $event)),
                      onChange: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.onEmptyPriceChange && _ctx.onEmptyPriceChange(...args)))
                    }, null, 544), [
                      [_vModelCheckbox, _ctx.v$.form.hasEmptyPrice.$model]
                    ]),
                    _hoisted_51
                  ]),
                  (_ctx.v$.form.price.$dirty && _ctx.v$.form.price.$invalid)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_ctx.v$.form.price.required.$invalid)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_52, _toDisplayString(_ctx.$t('forms.required')), 1))
                          : _createCommentVNode("", true),
                        (_ctx.v$.form.price.integer.$invalid)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_53, _toDisplayString(_ctx.$t('forms.integer')), 1))
                          : _createCommentVNode("", true),
                        (_ctx.v$.form.price.minValue.$invalid)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_54, _toDisplayString(_ctx.$t('forms.minValue', { value: _ctx.v$.form.price.minValue.$params.min })), 1))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true)
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.status.$error }])
                }, [
                  _createElementVNode("label", _hoisted_55, _toDisplayString(_ctx.$t('AdDeveloperProjectItem.status')) + ":", 1),
                  _createElementVNode("div", _hoisted_56, [
                    _withDirectives(_createElementVNode("select", {
                      id: "frm-estateAddForm_status",
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.v$.form.status.$model) = $event)),
                      name: "status",
                      class: "form-control"
                    }, [
                      _createElementVNode("option", _hoisted_57, _toDisplayString(_ctx.$t('AdDeveloperProjectItem.status-empty-option')), 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statuses, (item) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: item.key,
                          key: item.key
                        }, _toDisplayString(item.value), 9, _hoisted_58))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.v$.form.status.$model]
                    ])
                  ]),
                  (_ctx.v$.form.status.$dirty && _ctx.v$.form.status.$invalid)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_ctx.v$.form.status.required.$invalid)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_59, _toDisplayString(_ctx.$t('forms.required')), 1))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true)
                ], 2)
              ]),
              _hoisted_60
            ], 34)
          ]))
        : _createCommentVNode("", true),
      (_ctx.tabActiveIndex === 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
            _createElementVNode("form", _hoisted_62, [
              (_ctx.showFormMessages)
                ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (message, index) => {
                      return (_openBlock(), _createBlock(_component_FlashMessage, {
                        key: index,
                        message: message
                      }, null, 8, ["message"]))
                    }), 128)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (error, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "flashmessage flash-danger",
                        innerHTML: error
                      }, null, 8, _hoisted_64))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.importFile && _ctx.importFile.isError)
                ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                    (_ctx.importFile.isError)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_66, _toDisplayString(_ctx.importFile.text), 1))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_67, [
                _createElementVNode("div", _hoisted_68, [
                  _createElementVNode("div", _hoisted_69, [
                    _createElementVNode("div", _hoisted_70, [
                      _createElementVNode("div", _hoisted_71, [
                        _createElementVNode("div", _hoisted_72, [
                          _createElementVNode("label", _hoisted_73, [
                            _createElementVNode("input", {
                              type: "file",
                              id: "import-file",
                              ref: "importFile",
                              multiple: "",
                              onChange: _cache[17] || (_cache[17] = ($event: any) => (_ctx.handleFilesUpload())),
                              accept: ".xlsx, .xls"
                            }, null, 544),
                            _createElementVNode("span", _hoisted_74, _toDisplayString(_ctx.$t('AdDeveloperProjectItem.import.title')), 1)
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_75, [
                      _createElementVNode("div", _hoisted_76, _toDisplayString(_ctx.$t('AdDeveloperProjectItem.import.sample-title')), 1),
                      _createElementVNode("p", _hoisted_77, [
                        _createElementVNode("em", _hoisted_78, _toDisplayString(_ctx.$t('AdDeveloperProjectItem.import.sample-content')), 1)
                      ]),
                      (_ctx.importSampleFileUrl)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            href: _ctx.importSampleFileUrl,
                            class: "button button--primary reversed"
                          }, _toDisplayString(_ctx.$t('AdDeveloperProjectItem.import.sample-button')), 9, _hoisted_79))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                (_ctx.importFile && _ctx.importFile.isSuccess)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "button button--primary",
                        onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.startImport()))
                      }, "Importovať")
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}